
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { mapState } from 'vuex';
import DisableTip from './components/DisableTip.vue';
import moment from 'moment';
import conf from "./config/base.js";

const TERMINATED = 1, REDIRECT = 2; const DELAY_TERMINATED = 3; const DELAY_REDIRECT = 4;
const SourceFlag = {
xforceplus: REDIRECT,
shenhua: TERMINATED, // 神华
JZT: TERMINATED, // 九州通



minmetals: REDIRECT,
WKJT: REDIRECT, // 五矿
HISUN: REDIRECT, // 瀚晖制药
Excellence: REDIRECT, // 卓越
RCJT: REDIRECT, //融创

BGY: DELAY_REDIRECT, // 碧桂园
futureland: DELAY_REDIRECT, // 新城控股
JXYL: DELAY_REDIRECT 
}

export default {
name: 'app',
data() {
return {
appClass: '',
bodyPaddingTop: ____hasHeader ? '46px' : '0',
bodyPaddingBottom: '0px',
isDev: conf.envType !== 'PROD',
source: localStorage.getItem('source'),
isFullBuleBg:
this.$router.name == this.$routerNames.OrderInvoiceDetail ||
this.$router.name == this.$routerNames.InvoiceDetail,
hideNavArr:[
'futureland'
],
disableTipShow: false
};
},
components: {
Loading,
XHeader,
TransferDom,
Tabbar,
TabbarItem,
ViewBox,
DisableTip
},
directives: {
TransferDom,
},
mounted() {
var $self = this;
console.log('sourceFlag----', this.sourceFlag);
bus.$on("setHeader", () => {
this.getUserInfo()
});

const script = document.createElement('script');
script.src = 'https://s13.cnzz.com/z_stat.php?id=1273687207&web_id=1273687207';
script.language = 'JavaScript';
document.body.appendChild(script);
},
methods: {
getUserInfo() {
this.$webapi.getUserInfo().then(res => {
if (res.data.status == 1) {
const source = res.data.result.xfpUser.source;
this.source = source;
localStorage.setItem('source', source);
localStorage.setItem('otId',res.data.result.xfpUser.otId)
this.showNavBar(source)
if (res.data.result.userInfoExt) {
localStorage.setItem('allowCheckSignFlag',res.data.result.userInfoExt.allowCheckSignFlag)
}
if(source === 'RCJT'){ // 融创租户 暂停3.0票税助手使用
this.disableTipShow = true
}

}
});
},
showNavBar(source){
for(let v of this.hideNavArr){
if(v == source){
____hasHeader = false
}
}
this.appClass = ____hasHeader ? 'has-header' : '';
this.setPaddingTop()
this.setHeight()
},
setPaddingTop(){
this.bodyPaddingTop = ____hasHeader ? '46px' : '0'
},
setHeight(){

____invoiceScrollerHeight = document.documentElement.clientHeight - (____hasHeader ? 46 : 0) - 44; 
____invoiceScrollerHeight2 = 0 - (____hasHeader ? 46 : 0) - 44;
},
save() {
console.log('sssssssss');


},
showTip() {
var $self = this;
console.log('sourceFlagChange----', $self.sourceFlag);
if ([3, 4].includes($self.sourceFlag) && !$self.isDelay) {
$self.$vux.alert.show({
title: $self.$t('提示'),
content: $self.sourceFlag === 4 ?
$self.$t(`贵司${$self.isDev ? `(租户: ${$self.source})` : ''}影像采集功能即将升级到新系统，现【票税助手】将于2024年12月31日24时关停无法使用，请在升级完成后搜索公众号【票易拍】以继续使用，感谢您的理解与配合。`)
: $self.$t(`【票税助手】将于2024年12月31日24时关停无法使用，如有疑问，请联系贵司${$self.isDev ? `(租户: ${$self.source})` : ''}内部负责人员与我司相关人员接洽，感谢您的理解与配合。`),
});
}
}
},
watch: {
$route(val) {

if (window._czc) {
var location = window.location;
var contentUrl = location.pathname + location.hash;
var refererUrl = '/';
window._czc.push(['_trackPageview', contentUrl, refererUrl]);
}

document.title = this.$t(val.meta.title);
if (____isAlipayBrowser()){
AlipayJSBridge.call('setTitle', {
title: this.$t(val.meta.title),
});
}
},
sourceFlag(value){
this.showTip();
}
},
computed: {
...mapState({
isLoading: state => state.common.isLoading,
direction: state => state.common.direction,
}),
viewTransition() {
var $self = this;
if (!$self.direction) return '';
return 'vux-pop-' + ('xxxx' === $self.direction ? 'xxxx' : $self.direction === 'forward' ? 'in' : 'out');

} /*,
headerTransition() {
if (!this.direction) return "";
return this.direction === "forward"
? "vux-header-fade-in-right"
: "vux-header-fade-in-left";
}*/,
sourceFlag() {
return this.$route.meta.showTabbar ? SourceFlag[this.source] || DELAY_TERMINATED : undefined
},
isDelay() {
return moment().isAfter(this.isDev ? localStorage.getItem('delayTime') || '2025-01-01' : '2025-01-01');
}
},
};
